export const adminLinks = {
  users: {
    to: { name: 'admin-manage-admins' },
  },
  roles: {
    to: { name: 'admin-default-roles' },
  },
  services: {
    to: { name: 'admin-billing-services' },
  },
  coupons: {
    to: { name: 'admin-billing-coupons' },
  },
  function: {
    to: { name: 'admin-manage-functions' },
  },
  impersonate: {
    to: { name: 'admin-impersonate' },
  },
  'import-export': {
    to: {
      name: 'admin-import-export',
      params: {
        tab: 'functions',
      },
    },
  },
}
